import { User } from "@/lib/user/mod"

const SuperAdminDomains = new Set(["fluentgroup.com.au", "landersystems.com"])

export type Role = "user" | "admin" | "superadmin"

export const isSuperAdmin = (user?: User | null) =>
  (user && SuperAdminDomains.has(user?.email.split("@")[1] ?? "")) || false

export const isAdmin = (user?: User | null) => {
  return (user && (user.role === "Admin" || isSuperAdmin(user))) || false
}
